import {
    ComponentCodeAnchor,
    ComponentCodeVersion,
} from 'src/models/anchor-and-version/component-code.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-component-code-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudComponentCodeModalComponent extends CrudModalAbstractComponent<
    ComponentCodeAnchor,
    ComponentCodeVersion
> {
    public modalProps: ModalProps = {
        title: 'Component Code',
        anchorFields: [],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 2 },
            { field: 'type', label: 'Type', type: 'text', required: true, order: 3 },
            {
                field: 'description',
                label: 'Description',
                type: 'textarea',
                required: true,
                order: 4,
            },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 5 },
        ],
    };
}
